import { render, staticRenderFns } from "./TransferTokenDialog.vue?vue&type=template&id=5052bc74&scoped=true"
import script from "./TransferTokenDialog.vue?vue&type=script&lang=js"
export * from "./TransferTokenDialog.vue?vue&type=script&lang=js"
import style0 from "./TransferTokenDialog.vue?vue&type=style&index=0&id=5052bc74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5052bc74",
  null
  
)

export default component.exports